import blurb_cloud_left from '../images/blurb_cloud_left.svg'
import blurb_cloud_back from '../images/blurb_cloud_back.svg'
import blurb_cloud_right from '../images/blurb_cloud_right.svg'
import { mediaQueries } from '../shared/config';

import styled from 'styled-components';

const BlurbContainer = styled.div`
    position: relative;
    height: 50vh;
    margin-top: 10vh;
    margin-bottom: 10vh;
    z-index: -10;

`

const BlurbSection = styled.div`
    position: relative;
    margin-top: 10px;
    margin-bottom: 10px;

    .left_cloud {
        position: relative;
        left: 20px;
        width: 60vw;
        z-index: 1; // make this image render on top of the bottom
        margin-top: 10%;

      }

    .back_cloud {
        margin-top: 19%;
        position: absolute;
        left: 33vw;
        width: 40vw;
    }
        
    .right_cloud {
        margin-top: 10%;
        position: absolute;
        right: 0px;
        width: 42vw;
        z-index: 2; // make this image render on top of the bottom
    }
`
    

    const Container = styled.div`
    z-index: 10;
    margin-left: 30%;
    transform: translate(0, -35vh); /* Translate the component */
    width: 70vh;
    height: fit-content;
    min-height: 20vh;
    background: rgba(255, 255, 255, 0.75);
    border-radius: 16px;
    border-style: solid;
    border-color: white;
    border-width: 1px;
    transform: translate(0vh, -55vh); /* Translate the component */
   

    ${mediaQueries.mobile} {
        width: 40vh;
        transform: translate(-12vh, -30vh); /* Translate the component */

    }
`

const Title = styled.div`
    font-family: "Playfair Display", serif;
    font-weight: 400px;
    font-size: 3.2vh;
    text-align: left;
    // margin-left: 3vh;
    // margin-right: 9vh;
    // margin-top: 3vh;
    // margin-bottom: 0vh;
    color:#9E7EC7;
    padding: 6vh;
    padding-left: 8vh;
    padding-right: 8vh;

    ${mediaQueries.mobile} {
        font-size: 24px;
        font-size: 2.2vh;
        padding-left: 8vh;
    }

`


const Blurb = (props) => {
    return (
        <><BlurbContainer>
            <BlurbSection>
                <div class="right_cloud"><img src={blurb_cloud_right} /></div>
                <div class="back_cloud"><img src={blurb_cloud_back} /></div>
                <div class="left_cloud"><img src={blurb_cloud_left} /></div>
            </BlurbSection>
        </BlurbContainer>
            <Container color={props.article_color}>
                <Title>{props.blurb_text} </Title>
            </Container></>
    );
};

export default Blurb;